import type { PlayerInput } from '../multiplayer/PlayerInput';
export type Avatar = 'cat' | 'penguin' | 'walker';
export type Phase = 'lobby' | 'countdown' | 'playing' | 'finished';
export interface OnlinePlayer {
 id:string; name:string; avatar:Avatar; slot:number; connected:boolean; ready:boolean;
 x:number; y:number; col:number; row:number; moving:boolean; direction:'up'|'down'|'left'|'right';
 alive:boolean; lives:number; bombs:number; radius:number; speed:number; shield:boolean;
 remote:boolean; kick:boolean; wallPass:boolean; bombPass:boolean; fireUntil:number; immuneUntil:number; wins:number;
}
export interface OnlineBomb { id:number; owner:string; col:number; row:number; radius:number; explodeAt:number; remote:boolean; }
export interface OnlineFlame { id:number; col:number; row:number; until:number; }
export interface OnlineItem { col:number; row:number; type:string; }
export interface RoomSnapshot {
 code:string; hostId:string; capacity:number; phase:Phase; round:number; time:number; startsAt:number;
 endsAt:number; winnerId:string|null; grid:number[][]; players:OnlinePlayer[]; bombs:OnlineBomb[];
 flames:OnlineFlame[]; items:OnlineItem[];
}
export type ClientMessage =
 | {type:'create'; name:string; avatar:Avatar; capacity:number}
 | {type:'join'; code:string; name:string; avatar:Avatar}
 | {type:'resume'; code:string; token:string}
 | {type:'ready'; ready:boolean}
 | {type:'start'} | {type:'rematch'} | {type:'leave'}
 | {type:'input'; seq:number; input:PlayerInput};
export type ServerMessage =
 | {type:'welcome'; id:string; token:string; room:RoomSnapshot}
 | {type:'snapshot'; room:RoomSnapshot}
 | {type:'error'; message:string}
 | {type:'pong'; at:number};
export const neutralInput = (): PlayerInput => ({up:false,down:false,left:false,right:false,bomb:false,detonate:false});
